import { BALANCE } from '../config/balance';
import type { BuildState, WeaponId } from '../core/types';
import { EVOLUTION_IDS } from './build';
import { BoomerangController } from './weapon-boomerang';
import { StaffController } from './weapon-staff';
import { WhipController } from './weapon-whip';
import { ArrowController } from './weapon-arrow';
import type { WeaponController } from './weapon-controller';
import type { Engine } from './engine';

/** 全部武器的聚合：构筑同步与逐帧更新。 */
export class WeaponSet {
  boomerang = new BoomerangController();
  staff = new StaffController();
  whip = new WhipController();
  arrow = new ArrowController();
  private readonly list: readonly WeaponController[];

  constructor() {
    this.list = [this.boomerang, this.staff, this.whip, this.arrow];
  }

  private isEvolved(b: BuildState, w: WeaponId): boolean {
    for (const id of EVOLUTION_IDS) {
      if (BALANCE.evolutions[id].weapon === w && b.evolved[id]) return true;
    }
    return false;
  }

  syncBuild(b: BuildState): void {
    for (const c of this.list) {
      c.syncBuild(b.weapon[c.id], this.isEvolved(b, c.id));
    }
  }

  update(engine: Engine, dt: number): void {
    for (const c of this.list) c.update(engine, dt);
  }
}
